document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-inspiring-section]');

  sections.forEach((section) => {
    const track = section.querySelector('[data-inspiring-track]');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    items.forEach((item) => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });

    const itemWidth = items[0].offsetWidth + 16;
    const totalWidth = itemWidth * items.length;
    const duration = Math.max(20, totalWidth / 40);

    track.style.setProperty('--inspiring-scroll-duration', `${duration}s`);
    section.style.setProperty('--inspiring-scroll-duration', `${duration}s`);
  });
});
